import { Component, Input, OnChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslationService } from '../services/translation.service';
import { RouteInstructionVm } from './routing.models';
import { inject } from '@angular/core';

@Component({
  selector: 'app-route-walk-instruction',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="route-walk-instruction-container">
      <div>{{ walkDistance }}</div>
      <hr />
    </div>
  `,
  styles: []
})
export class RouteWalkInstructionComponent implements OnChanges {
  @Input() instruction!: RouteInstructionVm;

  private translationService = inject(TranslationService);
  private readonly walkLiteral = 'Walk ';

  walkDistance = '';

  ngOnChanges(): void {
    if (!this.instruction) return;
    const translated = this.translationService.translate('route_instruction_walk');
    const rawText = this.instruction.originalInstruction.text.replace(this.walkLiteral, '');
    this.walkDistance = `${translated} ${rawText}`;
  }
}
